import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Gift } from '../gift/gift';
import { ConfigurationService} from '../shared/configuration.service';

@Injectable()
export class HttpService {
  private headers = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: Http,
        private _configuration:ConfigurationService) { }

  get(url: string): Observable<Gift[]> {
    return this.http.get(this._configuration.baseUrl + url)
      .map(this.extractData)
      .catch(this.handleError);
  }


  getFromUrl(url: string): Promise<any> {
    let hostBase: string;
    // if (!parent) {
    //   hostBase = this._configuration.apiHost;
    //   this.progessService.setProgressValue(true);
    // } else {
    //   hostBase = this._configuration.apiParentHost
    // }
    return this.http.get(this._configuration.baseUrl + url).toPromise().then(response => response.json() as any).catch(this.handleError);
  }


  create(url: string, body: any): Promise<any> {

    return this.http
      .post(url, body, { headers: this.headers })
      .toPromise()
      .then(res => res)//res.json().data)
      .catch(this.handleError);

  }
  private extractData(res: Response) {
     
    let body = res.json();
    return body || {};
  }


  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/http.service.ts